import { EventMeta } from '../../../interfaces/meta.interface';

const moveToDeletedItems: EventMeta = {
    title: 'Move To Deleted Items',
    default: {
        description: 'Move To Deleted Items',
        longDescription: 'A message was deleted and moved to the Deleted Items folder.',
        severity: 'info',
    },
};

export default moveToDeletedItems;
